/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { Individu } from '@/types';

const validationStep5 = (individu: Individu) => {
  // 
  return {};
};

export default validationStep5;
